
/**
 * @sveltech/routify 1.9.9
 * File generated Wed May 28 2025 15:11:33 GMT+0000 (Coordinated Universal Time)
 */

export const __version = "1.9.9"
export const __timestamp = "2025-05-28T15:11:33.683Z"

//buildRoutes
import { buildClientTree } from "@sveltech/routify/runtime/buildRoutes"

//imports


//options
export const options = {}

//tree
export const _tree = {
  "name": "root",
  "filepath": "/",
  "root": true,
  "ownMeta": {},
  "absolutePath": "src/pages",
  "children": [
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": true,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/_fallback",
      "id": "__fallback",
      "component": () => import('../../../../src/pages/_fallback.svelte').then(m => m.default)
    },
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": true,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/",
      "id": "__layout",
      "component": () => import('../../../../src/pages/_layout.svelte').then(m => m.default)
    },
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/businesses",
      "id": "_businesses",
      "component": () => import('../../../../src/pages/businesses.svelte').then(m => m.default)
    },
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/contact",
      "id": "_contact",
      "component": () => import('../../../../src/pages/contact.svelte').then(m => m.default)
    },
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/developers",
      "id": "_developers",
      "component": () => import('../../../../src/pages/developers.svelte').then(m => m.default)
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": true,
          "isReset": true,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/documentation",
          "id": "_documentation__reset",
          "component": () => import('../../../../src/pages/documentation/_reset.svelte').then(m => m.default)
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "md",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/documentation/developers/build-env",
              "id": "_documentation_developers_buildEnv",
              "component": () => import('../../../../src/pages/documentation/developers/build-env.md').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "md",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/documentation/developers/build-nymea",
              "id": "_documentation_developers_buildNymea",
              "component": () => import('../../../../src/pages/documentation/developers/build-nymea.md').then(m => m.default)
            },
            {
              "isFile": false,
              "isDir": true,
              "ext": "",
              "children": [
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/developers/clients/client-development",
                  "id": "_documentation_developers_clients_clientDevelopment",
                  "component": () => import('../../../../src/pages/documentation/developers/clients/client-development.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/developers/clients/json-rpc",
                  "id": "_documentation_developers_clients_jsonRpc",
                  "component": () => import('../../../../src/pages/documentation/developers/clients/json-rpc.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/developers/clients/nymea-app-lib",
                  "id": "_documentation_developers_clients_nymeaAppLib",
                  "component": () => import('../../../../src/pages/documentation/developers/clients/nymea-app-lib.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/developers/clients/nymea-cli-dev",
                  "id": "_documentation_developers_clients_nymeaCliDev",
                  "component": () => import('../../../../src/pages/documentation/developers/clients/nymea-cli-dev.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "svelte",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/developers/clients/raw-api",
                  "id": "_documentation_developers_clients_rawApi",
                  "component": () => import('../../../../src/pages/documentation/developers/clients/raw-api.svelte').then(m => m.default)
                }
              ],
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": false,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/documentation/developers/clients"
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "md",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/documentation/developers/clients",
              "id": "_documentation_developers_clients",
              "component": () => import('../../../../src/pages/documentation/developers/clients.md').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "md",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/documentation/developers/developing-with-qt-creator",
              "id": "_documentation_developers_developingWithQtCreator",
              "component": () => import('../../../../src/pages/documentation/developers/developing-with-qt-creator.md').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "md",
              "isLayout": false,
              "isReset": false,
              "isIndex": true,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/documentation/developers/index",
              "id": "_documentation_developers_index",
              "component": () => import('../../../../src/pages/documentation/developers/index.md').then(m => m.default)
            },
            {
              "isFile": false,
              "isDir": true,
              "ext": "",
              "children": [
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/developers/integrations/building-testing",
                  "id": "_documentation_developers_integrations_buildingTesting",
                  "component": () => import('../../../../src/pages/documentation/developers/integrations/building-testing.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/developers/integrations/creating-a-new-plugin",
                  "id": "_documentation_developers_integrations_creatingANewPlugin",
                  "component": () => import('../../../../src/pages/documentation/developers/integrations/creating-a-new-plugin.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/developers/integrations/getting-started-integration",
                  "id": "_documentation_developers_integrations_gettingStartedIntegration",
                  "component": () => import('../../../../src/pages/documentation/developers/integrations/getting-started-integration.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/developers/integrations/interfaces",
                  "id": "_documentation_developers_integrations_interfaces",
                  "component": () => import('../../../../src/pages/documentation/developers/integrations/interfaces.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/developers/integrations/plugin-code",
                  "id": "_documentation_developers_integrations_pluginCode",
                  "component": () => import('../../../../src/pages/documentation/developers/integrations/plugin-code.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/developers/integrations/plugin-json",
                  "id": "_documentation_developers_integrations_pluginJson",
                  "component": () => import('../../../../src/pages/documentation/developers/integrations/plugin-json.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/developers/integrations/submitting",
                  "id": "_documentation_developers_integrations_submitting",
                  "component": () => import('../../../../src/pages/documentation/developers/integrations/submitting.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/developers/integrations/thing-class",
                  "id": "_documentation_developers_integrations_thingClass",
                  "component": () => import('../../../../src/pages/documentation/developers/integrations/thing-class.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/developers/integrations/thing-setup",
                  "id": "_documentation_developers_integrations_thingSetup",
                  "component": () => import('../../../../src/pages/documentation/developers/integrations/thing-setup.md').then(m => m.default)
                }
              ],
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": false,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/documentation/developers/integrations"
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "md",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/documentation/developers/write-plugins",
              "id": "_documentation_developers_writePlugins",
              "component": () => import('../../../../src/pages/documentation/developers/write-plugins.md').then(m => m.default)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/documentation/developers"
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "md",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/documentation/overview/about-nymea",
              "id": "_documentation_overview_aboutNymea",
              "component": () => import('../../../../src/pages/documentation/overview/about-nymea.md').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "md",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/documentation/overview/changelog",
              "id": "_documentation_overview_changelog",
              "component": () => import('../../../../src/pages/documentation/overview/changelog.md').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "md",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/documentation/overview/contribute",
              "id": "_documentation_overview_contribute",
              "component": () => import('../../../../src/pages/documentation/overview/contribute.md').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "md",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/documentation/overview/features",
              "id": "_documentation_overview_features",
              "component": () => import('../../../../src/pages/documentation/overview/features.md').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "md",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/documentation/overview/license",
              "id": "_documentation_overview_license",
              "component": () => import('../../../../src/pages/documentation/overview/license.md').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "md",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/documentation/overview/nymea-in-action",
              "id": "_documentation_overview_nymeaInAction",
              "component": () => import('../../../../src/pages/documentation/overview/nymea-in-action.md').then(m => m.default)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/documentation/overview"
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": false,
              "isDir": true,
              "ext": "",
              "children": [
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "svelte",
                  "isLayout": true,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": false,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/api",
                  "id": "_documentation_resources_api__layout",
                  "component": () => import('../../../../src/pages/documentation/resources/api/_layout.svelte').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "svelte",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/api/:namespace",
                  "id": "_documentation_resources_api__namespace",
                  "component": () => import('../../../../src/pages/documentation/resources/api/[namespace].svelte').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "svelte",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/api/heading",
                  "id": "_documentation_resources_api_heading",
                  "component": () => import('../../../../src/pages/documentation/resources/api/heading.svelte').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "svelte",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": true,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/api/index",
                  "id": "_documentation_resources_api_index",
                  "component": () => import('../../../../src/pages/documentation/resources/api/index.svelte').then(m => m.default)
                }
              ],
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": false,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/documentation/resources/api"
            },
            {
              "isFile": false,
              "isDir": true,
              "ext": "",
              "children": [
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "svelte",
                  "isLayout": true,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": false,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations",
                  "id": "_documentation_resources_integrations__layout",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/_layout.svelte').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "svelte",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/:category",
                  "id": "_documentation_resources_integrations__category",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/[category].svelte').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/alphainnotec",
                  "id": "_documentation_resources_integrations_alphainnotec",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/alphainnotec.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/amperfied",
                  "id": "_documentation_resources_integrations_amperfied",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/amperfied.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/anel",
                  "id": "_documentation_resources_integrations_anel",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/anel.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/aqi",
                  "id": "_documentation_resources_integrations_aqi",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/aqi.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/avahimonitor",
                  "id": "_documentation_resources_integrations_avahimonitor",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/avahimonitor.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/awattar",
                  "id": "_documentation_resources_integrations_awattar",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/awattar.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/bgetech",
                  "id": "_documentation_resources_integrations_bgetech",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/bgetech.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/bimmerconnected",
                  "id": "_documentation_resources_integrations_bimmerconnected",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/bimmerconnected.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/bluos",
                  "id": "_documentation_resources_integrations_bluos",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/bluos.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/bose",
                  "id": "_documentation_resources_integrations_bose",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/bose.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/bosswerk",
                  "id": "_documentation_resources_integrations_bosswerk",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/bosswerk.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/coinmarketcap",
                  "id": "_documentation_resources_integrations_coinmarketcap",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/coinmarketcap.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/commandlauncher",
                  "id": "_documentation_resources_integrations_commandlauncher",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/commandlauncher.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/daikinairco",
                  "id": "_documentation_resources_integrations_daikinairco",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/daikinairco.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/datetime",
                  "id": "_documentation_resources_integrations_datetime",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/datetime.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/daylightsensor",
                  "id": "_documentation_resources_integrations_daylightsensor",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/daylightsensor.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/denon",
                  "id": "_documentation_resources_integrations_denon",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/denon.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/doorbird",
                  "id": "_documentation_resources_integrations_doorbird",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/doorbird.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/drexelundweiss",
                  "id": "_documentation_resources_integrations_drexelundweiss",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/drexelundweiss.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/dweetio",
                  "id": "_documentation_resources_integrations_dweetio",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/dweetio.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/dynatrace",
                  "id": "_documentation_resources_integrations_dynatrace",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/dynatrace.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/easee",
                  "id": "_documentation_resources_integrations_easee",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/easee.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/elgato",
                  "id": "_documentation_resources_integrations_elgato",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/elgato.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/eq-3",
                  "id": "_documentation_resources_integrations_eq3",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/eq-3.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/espsomfyrts",
                  "id": "_documentation_resources_integrations_espsomfyrts",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/espsomfyrts.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/evbox",
                  "id": "_documentation_resources_integrations_evbox",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/evbox.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/everest",
                  "id": "_documentation_resources_integrations_everest",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/everest.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/fastcom",
                  "id": "_documentation_resources_integrations_fastcom",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/fastcom.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/flowercare",
                  "id": "_documentation_resources_integrations_flowercare",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/flowercare.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/fronius",
                  "id": "_documentation_resources_integrations_fronius",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/fronius.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/garadget",
                  "id": "_documentation_resources_integrations_garadget",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/garadget.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/goecharger",
                  "id": "_documentation_resources_integrations_goecharger",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/goecharger.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/gpio",
                  "id": "_documentation_resources_integrations_gpio",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/gpio.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/homeconnect",
                  "id": "_documentation_resources_integrations_homeconnect",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/homeconnect.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/httpcommander",
                  "id": "_documentation_resources_integrations_httpcommander",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/httpcommander.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/huawei",
                  "id": "_documentation_resources_integrations_huawei",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/huawei.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/i2cdevices",
                  "id": "_documentation_resources_integrations_i2cdevices",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/i2cdevices.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/idm",
                  "id": "_documentation_resources_integrations_idm",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/idm.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/inepro",
                  "id": "_documentation_resources_integrations_inepro",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/inepro.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/inro",
                  "id": "_documentation_resources_integrations_inro",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/inro.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/keba",
                  "id": "_documentation_resources_integrations_keba",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/keba.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/kodi",
                  "id": "_documentation_resources_integrations_kodi",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/kodi.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/kostal",
                  "id": "_documentation_resources_integrations_kostal",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/kostal.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/lgsmarttv",
                  "id": "_documentation_resources_integrations_lgsmarttv",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/lgsmarttv.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/lifx",
                  "id": "_documentation_resources_integrations_lifx",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/lifx.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/logilink",
                  "id": "_documentation_resources_integrations_logilink",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/logilink.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/mailnotification",
                  "id": "_documentation_resources_integrations_mailnotification",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/mailnotification.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/mcp3008",
                  "id": "_documentation_resources_integrations_mcp3008",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/mcp3008.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/mecelectronics",
                  "id": "_documentation_resources_integrations_mecelectronics",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/mecelectronics.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/mennekes",
                  "id": "_documentation_resources_integrations_mennekes",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/mennekes.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/meross",
                  "id": "_documentation_resources_integrations_meross",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/meross.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/modbuscommander",
                  "id": "_documentation_resources_integrations_modbuscommander",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/modbuscommander.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/mqttclient",
                  "id": "_documentation_resources_integrations_mqttclient",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/mqttclient.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/mypv",
                  "id": "_documentation_resources_integrations_mypv",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/mypv.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/mystrom",
                  "id": "_documentation_resources_integrations_mystrom",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/mystrom.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/nanoleaf",
                  "id": "_documentation_resources_integrations_nanoleaf",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/nanoleaf.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/neatobotvac",
                  "id": "_documentation_resources_integrations_neatobotvac",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/neatobotvac.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/netatmo",
                  "id": "_documentation_resources_integrations_netatmo",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/netatmo.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/networkdetector",
                  "id": "_documentation_resources_integrations_networkdetector",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/networkdetector.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/notifyevents",
                  "id": "_documentation_resources_integrations_notifyevents",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/notifyevents.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/nuki",
                  "id": "_documentation_resources_integrations_nuki",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/nuki.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/nymea-plugin-knx",
                  "id": "_documentation_resources_integrations_nymeaPluginKnx",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/nymea-plugin-knx.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/onewire",
                  "id": "_documentation_resources_integrations_onewire",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/onewire.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/openuv",
                  "id": "_documentation_resources_integrations_openuv",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/openuv.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/openweathermap",
                  "id": "_documentation_resources_integrations_openweathermap",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/openweathermap.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/osdomotics",
                  "id": "_documentation_resources_integrations_osdomotics",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/osdomotics.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/pcelectric",
                  "id": "_documentation_resources_integrations_pcelectric",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/pcelectric.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/philipshue",
                  "id": "_documentation_resources_integrations_philipshue",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/philipshue.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/phoenixconnect",
                  "id": "_documentation_resources_integrations_phoenixconnect",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/phoenixconnect.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/powerfox",
                  "id": "_documentation_resources_integrations_powerfox",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/powerfox.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/pushbullet",
                  "id": "_documentation_resources_integrations_pushbullet",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/pushbullet.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/reversessh",
                  "id": "_documentation_resources_integrations_reversessh",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/reversessh.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/schrack",
                  "id": "_documentation_resources_integrations_schrack",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/schrack.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/senic",
                  "id": "_documentation_resources_integrations_senic",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/senic.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/senseair",
                  "id": "_documentation_resources_integrations_senseair",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/senseair.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/serialportcommander",
                  "id": "_documentation_resources_integrations_serialportcommander",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/serialportcommander.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/sgready",
                  "id": "_documentation_resources_integrations_sgready",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/sgready.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/shelly",
                  "id": "_documentation_resources_integrations_shelly",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/shelly.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/simpleheatpump",
                  "id": "_documentation_resources_integrations_simpleheatpump",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/simpleheatpump.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/sma",
                  "id": "_documentation_resources_integrations_sma",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/sma.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/solarlog",
                  "id": "_documentation_resources_integrations_solarlog",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/solarlog.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/solax",
                  "id": "_documentation_resources_integrations_solax",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/solax.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/somfytahoma",
                  "id": "_documentation_resources_integrations_somfytahoma",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/somfytahoma.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/sonos",
                  "id": "_documentation_resources_integrations_sonos",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/sonos.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/spothinta",
                  "id": "_documentation_resources_integrations_spothinta",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/spothinta.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/stiebeleltron",
                  "id": "_documentation_resources_integrations_stiebeleltron",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/stiebeleltron.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/sungrow",
                  "id": "_documentation_resources_integrations_sungrow",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/sungrow.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/sunposition",
                  "id": "_documentation_resources_integrations_sunposition",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/sunposition.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/sunspec",
                  "id": "_documentation_resources_integrations_sunspec",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/sunspec.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/systemmonitor",
                  "id": "_documentation_resources_integrations_systemmonitor",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/systemmonitor.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/tado",
                  "id": "_documentation_resources_integrations_tado",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/tado.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/tasmota",
                  "id": "_documentation_resources_integrations_tasmota",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/tasmota.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/tcpcommander",
                  "id": "_documentation_resources_integrations_tcpcommander",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/tcpcommander.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/telegram",
                  "id": "_documentation_resources_integrations_telegram",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/telegram.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/tempo",
                  "id": "_documentation_resources_integrations_tempo",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/tempo.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/texasinstruments",
                  "id": "_documentation_resources_integrations_texasinstruments",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/texasinstruments.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/tmate",
                  "id": "_documentation_resources_integrations_tmate",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/tmate.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/tplink",
                  "id": "_documentation_resources_integrations_tplink",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/tplink.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/tuya",
                  "id": "_documentation_resources_integrations_tuya",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/tuya.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/udpcommander",
                  "id": "_documentation_resources_integrations_udpcommander",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/udpcommander.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/unifi",
                  "id": "_documentation_resources_integrations_unifi",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/unifi.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/unipi",
                  "id": "_documentation_resources_integrations_unipi",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/unipi.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/usbrelay",
                  "id": "_documentation_resources_integrations_usbrelay",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/usbrelay.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/usbrly82",
                  "id": "_documentation_resources_integrations_usbrly82",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/usbrly82.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/vestel",
                  "id": "_documentation_resources_integrations_vestel",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/vestel.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/wakeonlan",
                  "id": "_documentation_resources_integrations_wakeonlan",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/wakeonlan.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/wattsonic",
                  "id": "_documentation_resources_integrations_wattsonic",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/wattsonic.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/webasto",
                  "id": "_documentation_resources_integrations_webasto",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/webasto.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/wemo",
                  "id": "_documentation_resources_integrations_wemo",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/wemo.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/wheretheissat",
                  "id": "_documentation_resources_integrations_wheretheissat",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/wheretheissat.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/ws2812fx",
                  "id": "_documentation_resources_integrations_ws2812fx",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/ws2812fx.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/yamahaavr",
                  "id": "_documentation_resources_integrations_yamahaavr",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/yamahaavr.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/zigbeedevelco",
                  "id": "_documentation_resources_integrations_zigbeedevelco",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/zigbeedevelco.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/zigbeeeurotronic",
                  "id": "_documentation_resources_integrations_zigbeeeurotronic",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/zigbeeeurotronic.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/zigbeegeneric",
                  "id": "_documentation_resources_integrations_zigbeegeneric",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/zigbeegeneric.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/zigbeegewiss",
                  "id": "_documentation_resources_integrations_zigbeegewiss",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/zigbeegewiss.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/zigbeejung",
                  "id": "_documentation_resources_integrations_zigbeejung",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/zigbeejung.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/zigbeelumi",
                  "id": "_documentation_resources_integrations_zigbeelumi",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/zigbeelumi.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/zigbeeosram",
                  "id": "_documentation_resources_integrations_zigbeeosram",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/zigbeeosram.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/zigbeephilipshue",
                  "id": "_documentation_resources_integrations_zigbeephilipshue",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/zigbeephilipshue.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/zigbeeschneiderelectric",
                  "id": "_documentation_resources_integrations_zigbeeschneiderelectric",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/zigbeeschneiderelectric.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/zigbeetradfri",
                  "id": "_documentation_resources_integrations_zigbeetradfri",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/zigbeetradfri.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/zigbeetuya",
                  "id": "_documentation_resources_integrations_zigbeetuya",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/zigbeetuya.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/zwavefibaro",
                  "id": "_documentation_resources_integrations_zwavefibaro",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/zwavefibaro.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/zwavegeneric",
                  "id": "_documentation_resources_integrations_zwavegeneric",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/zwavegeneric.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/zwavequbino",
                  "id": "_documentation_resources_integrations_zwavequbino",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/zwavequbino.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/resources/integrations/zwavespringswindowfashions",
                  "id": "_documentation_resources_integrations_zwavespringswindowfashions",
                  "component": () => import('../../../../src/pages/documentation/resources/integrations/zwavespringswindowfashions.md').then(m => m.default)
                }
              ],
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": false,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/documentation/resources/integrations"
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/documentation/resources/integrations",
              "id": "_documentation_resources_integrations",
              "component": () => import('../../../../src/pages/documentation/resources/integrations.svelte').then(m => m.default)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "md",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/documentation/resources/interfaces",
              "id": "_documentation_resources_interfaces",
              "component": () => import('../../../../src/pages/documentation/resources/interfaces.md').then(m => m.default)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/documentation/resources"
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": false,
              "isDir": true,
              "ext": "",
              "children": [
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/users/advancedusage/sensor-on-mqtt-server",
                  "id": "_documentation_users_advancedusage_sensorOnMqttServer",
                  "component": () => import('../../../../src/pages/documentation/users/advancedusage/sensor-on-mqtt-server.md').then(m => m.default)
                }
              ],
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": false,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/documentation/users/advancedusage"
            },
            {
              "isFile": false,
              "isDir": true,
              "ext": "",
              "children": [
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/users/installation/app",
                  "id": "_documentation_users_installation_app",
                  "component": () => import('../../../../src/pages/documentation/users/installation/app.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/users/installation/core",
                  "id": "_documentation_users_installation_core",
                  "component": () => import('../../../../src/pages/documentation/users/installation/core.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/users/installation/getting-started",
                  "id": "_documentation_users_installation_gettingStarted",
                  "component": () => import('../../../../src/pages/documentation/users/installation/getting-started.md').then(m => m.default)
                }
              ],
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": false,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/documentation/users/installation"
            },
            {
              "isFile": false,
              "isDir": true,
              "ext": "",
              "children": [
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/users/usage/advanced-configuration",
                  "id": "_documentation_users_usage_advancedConfiguration",
                  "component": () => import('../../../../src/pages/documentation/users/usage/advanced-configuration.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/users/usage/configuration",
                  "id": "_documentation_users_usage_configuration",
                  "component": () => import('../../../../src/pages/documentation/users/usage/configuration.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/users/usage/first-steps",
                  "id": "_documentation_users_usage_firstSteps",
                  "component": () => import('../../../../src/pages/documentation/users/usage/first-steps.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/users/usage/rules",
                  "id": "_documentation_users_usage_rules",
                  "component": () => import('../../../../src/pages/documentation/users/usage/rules.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/users/usage/scripting",
                  "id": "_documentation_users_usage_scripting",
                  "component": () => import('../../../../src/pages/documentation/users/usage/scripting.md').then(m => m.default)
                },
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "md",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {},
                  "meta": {
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true
                  },
                  "path": "/documentation/users/usage/things",
                  "id": "_documentation_users_usage_things",
                  "component": () => import('../../../../src/pages/documentation/users/usage/things.md').then(m => m.default)
                }
              ],
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": false,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true
              },
              "path": "/documentation/users/usage"
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/documentation/users"
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/documentation"
    },
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/imprint",
      "id": "_imprint",
      "component": () => import('../../../../src/pages/imprint.svelte').then(m => m.default)
    },
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": true,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/index",
      "id": "_index",
      "component": () => import('../../../../src/pages/index.svelte').then(m => m.default)
    },
    {
      "isFile": true,
      "isDir": false,
      "ext": "md",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/sue",
      "id": "_sue",
      "component": () => import('../../../../src/pages/sue.md').then(m => m.default)
    },
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/users",
      "id": "_users",
      "component": () => import('../../../../src/pages/users.svelte').then(m => m.default)
    }
  ],
  "isLayout": false,
  "isReset": false,
  "isIndex": false,
  "isFallback": false,
  "meta": {
    "preload": false,
    "prerender": true,
    "precache-order": false,
    "precache-proximity": true,
    "recursive": true
  },
  "path": "/"
}


export const {tree, routes} = buildClientTree(_tree)

